import { AccessRequirementEnum, useNotify } from '@alice-financial/alice-sdk'
import * as React from 'react'
import { useNavigate } from 'react-router'
import { orgRootPath } from '../../orgDashboard/organization/useOrg'
import { OrganizationIntakeForm } from './OrganizationIntakeForm'

// Page wrapper component with header and container
export const IntakeFormPage: React.FC = () => {
  const navigate = useNavigate()
  const { notify } = useNotify()
  return (
    <OrganizationIntakeForm
      onSuccess={(orgId, access) => {
        // otherwise, notify user before navigating
        if (access === null || access !== AccessRequirementEnum.Ok) {
          notify({
            open: true,
            variant: 'success',
            message: 'Organization created, please log in using the email you provided.',
          })
        }
        navigate(orgRootPath(orgId))
      }}
    />
  )
}
